import React, { useContext } from 'react';
import API from 'helpers/API';
import { useParams } from 'react-router-dom';
import {
  getFormErrorsFromApiError,
  mapErrorObjectPropertiesMessagesToInputNamesErrors,
} from 'helpers/apiError';
import CardShell from '../../../components/CardShell';
import CustomEventTypeForm from './CustomEventTypeForm';
import CustomEventTypesContext from './CustomEventTypesContext';

const EditCustomEventType = () => {
  const { customEventTypes, loadCustomEventTypes } = useContext(CustomEventTypesContext);
  const { id } = useParams();

  const save = async (customEventType) => {
    try {
      await API.updateCustomEventType(id, customEventType);
    } catch (e) {
      if (e.status === 400) {
        const errorsMap = {
          name: { inputName: 'name', label: 'Name' },
        };
        const errors = getFormErrorsFromApiError(e.json);
        throw mapErrorObjectPropertiesMessagesToInputNamesErrors(errors, errorsMap);
      }
      throw e;
    }
    loadCustomEventTypes();
  };

  return (
    <div>
      <h1 className="h2">Edit Custom Event Type</h1>
      <div
        className="container__cards"
        style={{ background: '#f7f7f7', maxHeight: '190px' }}
      >
        <CardShell noOverflow>
          <CustomEventTypeForm save={save} customEventTypeId={id} customEventTypes={customEventTypes} />
        </CardShell>
      </div>
    </div>
  );
};

export default EditCustomEventType;
